import { IRegionMeta } from '../../types/regionMeta';
import { isMoscowOrMoscowArea, isSBPOrLo } from '../geo';

export function getBlackFridayRegionedUrl(url: string, currentRegion: IRegionMeta) {
  const concatenationSymbol = url.indexOf('?') > -1 ? '&' : '?';

  let regionId: number;

  if (isMoscowOrMoscowArea(currentRegion.parentId) || isSBPOrLo(currentRegion.parentId)) {
    regionId = currentRegion.id;
  } else {
    regionId = currentRegion.parentId ?? currentRegion.id;
  }

  return `${url}${concatenationSymbol}region=${regionId}`;
}
